import React from 'react';
import {SvgPdf, SvgVideo, SvgManual, SvgDonwload} from  '../Svg.js'
import { Link } from 'react-router-dom';


const Programas = () => {
  return (
    <div>
        <h1>Programas e Sistemas</h1>
        <div id = "texto2">  

<h3>PDV</h3>
    <p>O Ponto de Venda (PDV) ou Frente de Caixa é um dos nossos sistemas iniciais. Registra venda de produtos e serviços ou ainda de produtos e serviços simultaneamente. Faz a emissão Nota fiscal ao consumidor, tanto de produtos (ECF, SAT, NFC-e) como de serviços (RPS NFS-e). Registre meios de pagamento. Aciona o TEF. E tem opções para incluir informações personalizadas para cada ramo de negocio (Segmentos específicos).</p>
    <a href="./info/Folheto/PDV.pdf"><SvgPdf/></a>&nbsp;
    <Link to="/video6"><SvgVideo/></Link>
    <br/>
    <br/>

<h3>Retaguarda e ADM</h3>
    <h4>Retaguarda</h4>
    <p>Tabelas com Base de Dados do Sistema: Impostos, Tipo de Operações, Produtos e Serviços, Pagamentos e Descontos, Funcionários, Contas, Plano, Cotas, Frete, Índice e Valores, Anúncios, Trabalhos.
    Cadastro: Clientes, Fornecedores, Funcionários e etc.</p>
    <h4>ADM</h4>
    <p>
    <b>Tabelas:</b><br/> 
    Impostos, Tipo de Operações, Produtos e Serviços, Pagamentos e Descontos, Funcionários, Contas, Plano, Cotas, Frete, Índice e Valores, Anúncios, Trabalhos.<br/>
    Controle de Estoque.<br/> 
    <b>Cadastro:</b><br/> 
    Clientes, Fornecedores, Funcionários e etc.<br/>
    <b>Movimentos</b>:<br/>
    Registro de Vendas de Produtos e Serviços, Descontos e Pagamentos.<br/>
    Registro de Trocas com possibilidade de aproveitar o produto.<br/>
    Guarda de informações do PDV e dos Emissores.<br/>
    Pedidos de Compras de Produtos para Reposição. <br/>
    Livro Caixa.<br/>
    Cadastro de Clientes Endereço, Telefone, Complementos e Observações.<br/>
    Fechamento de Caixa, diário e mensal.<br/>
    Impressão de Relatórios, Listagens e Etiquetas.
    </p>
    <a href="./info/Folheto/Retaguarda e Adm.pdf"><SvgPdf/></a>&nbsp;
    <Link to="/video6"><SvgVideo/></Link>
    <br/>
    <br/>

<h3>Emissores Fiscais</h3>
    <h4>NFC-e - Nota Fiscal ao Consumidor Eletrônica</h4>
    <p>
    Sistema para comunicação como SEFAZ (Secretaria Estadual da Fazenda) para gerar, autenticar e transmitir os Cupons Fiscais Eletrônicos.<br/> 
    </p>
    <h4>RPS/NFS-e - Recibo Provisorio de serviços/Nota Fiscal de Serviços Eletrônica</h4>
    <p>
    Sistema para comunicação como as secretaria da Fazenda municipais para gerar, autenticar e transmitir os RPS e transfomalos em Nota Fiscal de Serviços Eletrônica.<br/> 
    </p>
    <h4>NF-e - Nota Fiscal Eletrônica</h4>
    <p>
    Sistema para comunicação como SEFAZ (Secretaria Estadual da Fazenda) para gerar, autenticar e transmitir Notas Fiscais de operação de circulação de mercadorias ou uma prestação de serviços.<br/> 
    </p>
    <a href="./info/Folheto/Emissores.pdf"><SvgPdf/></a>&nbsp;
    <br/>
    <br/>

<h3>Cadastro</h3>
    <p>
    Nosso modulo de Cadastro administra todas as informações de Clientes, Fornecedores, Funcionários, etc. Pessoas Físicas e Pessoas Jurídicas. Onde podemos incluir telefones, endereços, e-mails, ou qualquer forma de como entrar em contato, sem limite de quantidades. O cadastro de endereço e interligado a base de dados do “CEP Brasileiro” para minimizar a digitação com erros. E a visualização no “Google Stret” É possível ver na tela de Histórico todas as movimentações de informações de todos os outros módulos do sistema como: Vendas, Compras, Financeiro, Faturamento, etc. Todos os Cadastros são Classificados para futuras seleções e emissões de relatórios como: Listagem, Etiquetas, Pôs Venda, e muito mais. Ainda colocamos acesso a informações como Receita Federal, Serviços Nacional de Protestos, Sintegra (Gratuitos) e SPC e Serasa (Pagos), Podendo registra fotos, logotipos, e qualquer imagem. Botões de acesso rápido a telas personalizadas como: Veículos, Contratos, Grupo de Trabalhos, Lista de Preços exclusiva entre outras.
    </p>
    <a href="./info/Folheto/Cadastro.pdf"><SvgPdf/></a>&nbsp;
    <br/>
    <br/>

<h3>Consulta CEP</h3>
    <p>O Sistema realiza procura de CEP por endereço ou de endereço por CEP, além de verificar o DDD da localidade encontrada. Utiliza a base de dados oficial dos Correios e todas as atualizações realizadas nesta base de dados são prontamente disponibilizadas no site restrito da CRIAR para que sejam baixadas pelo usuário. Este sistema é bastante utilizado para que se tenha uma aplicação local, independente de acesso à internet, para a busca de CEP e endereços. Além disso, pode ser adicionado a qualquer sistema que não possua esta função ou ainda integrado a sistemas existentes nas empresas. Em sistemas Microsoft, tais como Word, Excel, Access etc., pode ser utilizado com integração automática. Por exemplo, é possível criar uma carta modelo no Word e com a integração do sistema Consulta CEP, a busca dos dados de endereço será automática.</p>
    <a href="./info/Folheto/CEP.pdf"><SvgPdf/></a>&nbsp;
    <a href="./info/Manual/CEP Manual.pdf"><SvgManual/></a>&nbsp;
    <a href="./"><SvgDonwload/></a>&nbsp;
    
    <br/>
    <br/>

<h3>Identificador de Chamadas</h3>
    <p>SiTef - Sistema de TEF (Transferência Eletrônica de Fundos). Sistema que Interliga-se a Soft Express (Principal empresa adquirente de transações financeiras de Cartão do Brasil), para autorizar o uso dos Cartões Cliente na loja.
    Todos os tipo de Cartões: Cartões de crédito e débito; Vouchers (refeição, alimentação;
    Todas as Bandeiras Pix Operação dentro do sistema de Vendas (PDV). </p>
    <a href="./info/Folheto/Identificador.pdf"><SvgPdf/></a>&nbsp;
    <a href="./info/Manual/Identificador de Chamadas Manua.pdf"><SvgManual/></a>&nbsp;
    <br/>
    <br/>

    <h3>SiTef Criar</h3>
    <p>Fica aguardando uma ligação telefônica (pelo MODEM) e quando toca o telefone, mostra na tela informações pre cadastradas do numero identificação: Nome, Endereços, telefones, ultimas compras, últimos produtos comprados e formas de pagamento usadas.
    Com Impressão do comprovante junto ao cupom fiscal.</p>
    <a href="./info/Folheto/SiTef Criar.pdf"><SvgPdf/></a>&nbsp;
    <br/>
    <br/>

<h3>Gerador de Documentos</h3>
    <p>Documentos em texto, Planilas, Gráficos e Relatorios impressos (PDF, CSV, TXT, HTML).
    <br/>
    Via Inteligência artificial, por descrições como linguagem natural, para gerar as informações.
    </p>
    <a href="./info/Folheto/Geradores.pdf"><SvgPdf/></a>&nbsp;
    <a href="./info/Manual/Documentos Manual.pdf"><SvgManual/></a>&nbsp;
 
    <br/>
    <br/>

<h3>Painel de Informação</h3>
    <p>
    <b>Painel de Informação</b><br/>
    Fica em Repetição continua mostrando imagens. Configuradas pelo usuário. Sem limite de quantidade imagens.
    <br/><br/>
    <b>Painel de Tabela de Preço</b><br/>
    Fica mostrado a tabela de Preço dos Produtos e serviços. Interligada ao sistema (Quando altera o preço no sistema muda no Painel).
    <br/><br/>
    <b>Exibição de Cozinha</b><br/>
    Mostra o itens a serem preparados, pela copa ou cozinha (Permite interação para registrar quando pronto).
    <br/><br/>
    <b>Controle de Fila</b><br/>
    Mostra o controle de itens a serem entregues para clientes (Permite interação para registrar quando entregue).
    <br/><br/>
    <b>Painel de Serviços</b><br/>
    Mostra oa serviços em andamento por cliente e a previsão de termino ou mudança de situação.
    </p>
    <a href="./info/Folheto/Painel.pdf"><SvgPdf/></a>&nbsp;
    <a href="./info/Manual/ Painel Manua.pdf"><SvgManual/></a>&nbsp;
    <br/>
    <br/>

<h3>Enviar e-mail</h3>
    <p>
    O programa envia e-mail em lote, gerados pelo sistema.<br/>
    Podemos personalizar o formado.<br/>
    Sem limite de remetentes.<br/>
    Inteligência para não ser detectado como AntiSpam.<br/>   
    </p>
    <a href="./info/Folheto/Envia.pdf"><SvgPdf/></a>&nbsp;
    <a href="./info/Manual/Envia Manual.pdf"><SvgManual/></a>&nbsp;
    <br/>
    <br/>

<h3>Consulta Preço</h3>
    <p>Escuta um ou vários IP de equipamentos de Busca Preço e envia para o Display as informações dos Produtos.<br/>
    Leitor de código de barras tem a Função "Cliente" que registra uma pre compra e Soma os itens lidos para mostrar o total.<br/>
    Tem tela de Configuração de Mensagens de descanso, propaganda enquanto não esta em uso e configuração de rede</p>
    <a href="./info/Folheto/ConsultaPreco.pdf"><SvgPdf/></a>&nbsp;
    <a href="./info/Manual/ConsultaPreco Manual.pdf"><SvgManual/></a>&nbsp;
    <br/>
    <br/>

<h3>Controlador de Micro Terminais</h3>
    <p>
    Fica escutando todos os micro terminais conectados na rede local e pede as informações ao operador necessários a venda.<br/>
    Tem arquivo de personalização de Teclas para executar funções<br/>
    Passa todas as informações para o PDV<br/>
    Tela de Configuração de Tara de Pratos para desconta nas Bandejas<br/>
    Controla display extra para visualizar de Clientes<br/>
    Relatório de lista de Códigos de Pratos/tara (Peso do Recipiente a ser descontado no peso total)<br/>
    Relatório com tara (peso) de cada prato com letra de 5 centímetros para ser colado com cartas, perto da balança, conforme legislação vigente.<br/>
    Configura automaticamente os parâmetro das balanças        </p>
    <a href="./info/Folheto/MicroTerminal.pdf"><SvgPdf/></a>&nbsp;
    <a href="./info/Manual/MicroTerminal Manua.pdf"><SvgManual/></a>&nbsp;
    <br/>
    <br/>

<h3>Controlador de Balança</h3>
    <p>
    Faz a leitura do peso de qualquer balança conectada na portas seriais Disponibiliza imediatamente o peso para todos os sistemas da Criar (Programas de computador, Tabletes e Celulares) Tem uma tela que funciona para dar entrada de vendas para o sistema PDV de produtos por peso e unidade faz a consulta de consumo registrados em fichas ou comandas Grava um arquivo na pasta DO SISTEMA o arquivo Peso.dat em formato CSV.
    </p>
    <a href="./info/Folheto/Balanca.pdf"><SvgPdf/></a>&nbsp;
    <a href="./info/Manual/Balança Manual.pdf"><SvgManual/></a>&nbsp;
    <br/>
    <br/>

    <h3>Controlador de Estacionamento</h3>
    <p>
    Sitema com visualição de todos os equipamentos em realide 3-d, controlaveis por toque como se fosse real.
    </p>
    <a href="./info/Estacionamento.pdf"><SvgPdf/></a>&nbsp;
    <Link to="/video9"><SvgVideo/></Link>
    <br/>
    <br/>



    <h3>Controlador de Lava Rapido</h3>
    <p>
    Sistema de Lava-rapido.
    </p>
    <br/>
    <br/>

    <h3>Controlador de Posto de Abastecimento</h3>
    <p>
    Sitema de Posto de Abastecimento.
    </p>
    <Link to="/video10"><SvgVideo/></Link>
    <br/>
    <br/>

    </div>
</div>
    )
};

export default Programas;
